import { Component, Element, h, Host, Prop } from '@stencil/core';

/**
 *
 */
@Component({
  tag: 'stzh-pi-quote',
  styleUrl: 'stzh-pi-quote.scss',
  scoped: true,
})
export class StzhPiQuote {
  @Element() element: HTMLStzhListElement;

  /* Text for quote */
  @Prop() text: string = '';

  /* Text for author */
  @Prop() author: string = '';

  render() {
    const classes = {
      'stzh-pi-quote': true,
    };

    return (
      <Host>
        <div class={classes}>
          <blockquote class="stzh-pi-quote__content">
            <p class="stzh-pi-quote__text">{this.text}</p>
            {this.author && (
              <cite class="stzh-pi-quote__author">{this.author}</cite>
            )}
          </blockquote>
        </div>
      </Host>
    );
  }
}
